import {
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CryptoService } from './crypto.service';

@Injectable({
  providedIn: 'root',
})
export class EncryptioninterceptorService {
  constructor(private _CryptoService: CryptoService) {
    // console.log("EncryptioninterceptorService RUN");
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // console.log("request", request.url);

    const urlsToSkip = [
      'get-ds-order-details',
      'pdas/get-inter-regional-order-tracking',
      'pdas/get-inter-regional-drop-tracking',
      'pdas/get-inter-state-order-tracking',
      'pdas/get-inter-state-drop-tracking',
    ];
    if (urlsToSkip.some((skipUrl) => request.url.includes(skipUrl))) {
      return next.handle(request); // Bypass decryption
    }

    if (request.headers.get('x-access-token')) {
      // Intercept only POST requests
      if (request.body) {
        const urlArr = request.url.split('/');
        // skip upload-imags-for-PDAS api
        if (urlArr[urlArr.length - 1] != 'upload-imags-for-PDAS') {
          // console.log('we are in body case', request.body);
          this._CryptoService.postKey = this._CryptoService.genrateKey();
          const encryptedBody = this._CryptoService.encryptData(
            JSON.stringify(request.body),
            this._CryptoService.postKey,
            this._CryptoService.base64
          );
          const decryptData = this._CryptoService.decryptData(
            encryptedBody,
            this._CryptoService.postKey,
            this._CryptoService.base64
          );
          // console.log("encryptedBody", encryptedBody);
          // console.log('decryptData', decryptData);
          request = request.clone({
            body: { request: encryptedBody },
          });
        }
      }
    } else {
      // console.log("if(!request.url?.includes('AWSAccessKeyId')){", request.url?.includes('503231305864752'));
      if (request.body) {
        // console.log('request.url===>', request.url);

        if (
          !request.url?.includes('https://graph.facebook.com') &&
          !request.url?.includes('downloadDeliveryAppFromAffiliateLink') &&
          !request.url?.includes('get-affiliate-code')
        ) {
          const urlArr = request.url.split('/');
          // if(urlArr[urlArr.length - 1] != 'validatePdasUserById'){

          const str = this._CryptoService.genrateRandomKeys(100);
          const encryptedBody = this._CryptoService.encryptData(
            JSON.stringify(request.body),
            str,
            null
          );
          const part1 = str.slice(0, str.length / 2);
          const part2 = str.slice(str.length / 2);

          request = request.clone({
            body: { request: part1 + encryptedBody + part2 },
          });
        }

        // }
      }
    }

    // Proceed with the modified request
    return next.handle(request);
  }
}
